type MassImportConfig = {
    lineLimitSiteSelectionLevel1: number,
    lineLimitSiteSelectionLevel2: number,
    siteSelectionLimitLevel1: number
}
const massImportConfig: MassImportConfig = (window as any).config.massImport;
export const LINE_LIMIT_SITE_SELECTION_LEVEL_1: number = massImportConfig.lineLimitSiteSelectionLevel1;
export const LINE_LIMIT_SITE_SELECTION_LEVEL_2: number = massImportConfig.lineLimitSiteSelectionLevel2;
export const SITE_SELECT_LIMIT_LEVEL_1: number = massImportConfig.siteSelectionLimitLevel1;